/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_TitleInputs */

const en_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Deletion`)
};

const fr_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la suppression`)
};

const de_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschung bestätigen`)
};

const it_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma eliminazione`)
};

const ru_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить удаление`)
};

const es_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar eliminación`)
};

const zh_cn2_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认删除`)
};

const ja_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除を確認`)
};

const hi_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलोपन की पुष्टि करें`)
};

const pt_pt2_context_menu_delete_title = /** @type {(inputs: Context_Menu_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar exclusão`)
};

/**
* | output |
* | --- |
* | "Confirm Deletion" |
*
* @param {Context_Menu_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_title = /** @type {((inputs?: Context_Menu_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete_title(inputs)
	if (locale === "de") return de_context_menu_delete_title(inputs)
	if (locale === "it") return it_context_menu_delete_title(inputs)
	if (locale === "ru") return ru_context_menu_delete_title(inputs)
	if (locale === "es") return es_context_menu_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete_title(inputs)
	if (locale === "ja") return ja_context_menu_delete_title(inputs)
	if (locale === "hi") return hi_context_menu_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete_title(inputs)
	return en_context_menu_delete_title(inputs)
});